/**
 * Action Types Creator
 *
 * This function will take an action name `actionName` (constant) and a hash
 * `actions` of nested actions. It returns a hash with same structure as
 * `actions` but each key is set to a full action type constant as a string.
 *
 * Example:
 *
 * // Input
 *
 * const actions = {
 *   UPDATE: ['TAGS', 'SINGLE_TAG']
 * }
 *
 * const FILTER = createActionTypes('FILTER', actions)
 *
 * // Output
 *
 * console.log(FILTER.UPDATE.SINGLE_TAG); // 'FILTER_UPDATE_SINGLE_TAG'
 *
 * console.log(FILTER);
 *
 * // FILTER = {
 * //   UPDATE: {
 * //     TAGS: 'FILTER_UPDATE_TAGS',
 * //     SINGLE_TAG: 'FILTER_UPDATE_SINGLE_TAG',
 * //   }
 * // }
 *
 */

const createActionTypes = (actionName, actions) => {
  const spreadArray = (hash, key, origin) => {
    const spread = {};
    hash.forEach(each => {
      spread[each] = origin
        .concat(key, each)
        .filter(i => !!i)
        .join('_');
    });
    return spread;
  };

  if (Array.isArray(actions)) {
    const name = [actionName];
    return spreadArray(actions, null, name);
  }

  Object.keys(actions).forEach(key => {
    const name = [actionName];
    if (Array.isArray(actions[key])) {
      actions[key] = spreadArray(actions[key], key, name);
    } else {
      actions[key] = name.concat(key).join('_');
    }
  });
  return actions;
};

export default createActionTypes;
